import axios from "axios";

// Boost Your Blog — ₹29 promotes ONE blog to 50 DIFFERENT users.
//
// Every number the boost pages show (unique views, remaining views, status,
// timestamps) comes from the server, never from this device: that is what
// makes a refresh, an app restart or a second device read the same campaign.

export const BASE_URL =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://success-blog-app-backend.onrender.com";

export const BOOST_PRICE = 29;
export const BOOST_MAX_VIEWS = 50;

const RAZORPAY_SRC = "https://checkout.razorpay.com/v1/checkout.js";

function authConfig() {
  const token = localStorage.getItem("token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

// The Boost page's state: the blog, and its newest campaign (live, finished
// or none at all). Owner only — the server refuses anybody else.
export async function getBoostStatus(blogId) {
  const res = await axios.get(`${BASE_URL}/api/boost/status/${blogId}`, authConfig());
  return res.data;
}

export async function getBoostAnalytics(blogId) {
  const res = await axios.get(`${BASE_URL}/api/boost/analytics/${blogId}`, authConfig());
  return res.data;
}

// Creates a Razorpay order only — nothing is activated until the payment is
// verified, so a cancelled payment leaves no campaign behind.
export async function createBoostOrder(blogId) {
  const res = await axios.post(
    `${BASE_URL}/api/boost/create-order`,
    { blogId },
    authConfig()
  );
  return res.data;
}

export async function verifyBoostPayment(payload) {
  const res = await axios.post(`${BASE_URL}/api/boost/verify`, payload, authConfig());
  return res.data;
}

// "This viewer has now read the boosted blog." Idempotent per person: only
// the first call for a (blog, viewer) pair is ever written.
export async function recordBoostView(blogId) {
  const res = await axios.post(`${BASE_URL}/api/boost/${blogId}/view`, {}, authConfig());
  return res.data;
}

// Razorpay's checkout script, loaded once per session and shared by every
// boost page (the membership page loads it the same way).
export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(false);
    if (window.Razorpay) return resolve(true);

    const existing = document.querySelector(`script[src="${RAZORPAY_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(Boolean(window.Razorpay)));
      existing.addEventListener("error", () => resolve(false));
      // Already finished loading before this listener was attached.
      if (window.Razorpay) resolve(true);
      return;
    }

    const script = document.createElement("script");
    script.src = RAZORPAY_SRC;
    script.async = true;
    script.onload = () => resolve(Boolean(window.Razorpay));
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

// ── shared formatting, so the boost page, the success screen and the
//    analytics page all print a date and a time the same way ──
export const formatDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatTime = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};
